import * as React from 'react';
import ApiBasic from '../api/ApiBasic';
import { MyStore, reducers } from '../redux';
import { InvoiceImport } from 'kts-platform-frame/display/part';
import { history } from 'kts-platform-frame/routes';
import Template from 'kts-platform-frame/display/components/InvoiceTemplate';
import * as configUtils from 'kts-platform-frame/entry/configUtils';
import { platform, message } from 'kts-platform-frame/api';
import CompanySelection from 'kts-platform-frame/display/part/CompanySelection';
import IOauth2CodeOptions from 'kts-platform-frame/api/platform/oauth2Code/IOptions';
import { Message, Event } from 'kts-scaffold-framework/message';
import service from 'kts-platform-frame/service';
import * as serviceTools from 'kts-platform-frame/service/Tools';
import myOpenApp, { IOptions as OpenAppIOptions } from './openApp';
import switchCompany from './switchCompany';
import getAppKey from './getAppKey';
import AppResource from './AppResource';
import sharedObject from 'kts-platform-frame/sharedObject';
import language from '../language';
import KtsSocket from 'kts-socket';

export default class AppSdk extends Message {

    /** 当前实例 */
    private static _instance: AppSdk;

    /** 获取当前实例 */
    public static get instance(): AppSdk {
        if (!AppSdk._instance) {
            AppSdk._instance = new AppSdk();
        }
        return AppSdk._instance;
    }

    /** 构造函数 */
    constructor() {
        super();
        if (AppSdk._instance) {
            throw ('对象为单利');
        } else {
            try {
                window.document.domain = window.location.host.split('.').slice(-3).join('.').split(':')[0];
            } catch (er) {
                console.error('domain设置失败。');
            }
        }
    }

    /** 框架跳转方法 */
    public get history() {
        return history;
    }

    /** 初始化 */
    public initialization() {
        window['$$_kxl_sdk'] = this;
    }

    /** 获取应用的权限资源 */
    public getAppResource(appKey: string) {
        return new AppResource(appKey)
    }

    /** 
     * myOpenApp 
     * @param target 开启app对象
     * @param app 开启的app key 或者 选项
     */
    public openApp(target: any, app: string | OpenAppIOptions, state?: any) {
        return myOpenApp(target, app, state);
    }

    /** Api基础类 */
    public get ApiBasic() {
        return ApiBasic;
    }

    /** ServiceAgent 实例 */
    public get service() {
        return service;
    }

    /** ServiceAgent 工具 实例 */
    public get serviceTools() {
        return serviceTools;
    }

    /** 共享对象 */
    public get sharedObject() {
        return sharedObject;
    }

    /** 语言 */
    public get language() {
        return language;
    }

    /** 获取当前的app key */
    public get getAppKey() {
        return getAppKey();
    }

    /** 配置数据 */
    public get config() {
        return MyStore.instance.getState().config;
    }

    /** 环境数据 */
    public get env() {
        return MyStore.instance.getState().env;
    }

    /** 用户数据 */
    public get user() {
        return MyStore.instance.getState().user;
    }

    /** 设置用户数据 */
    public setUser(value: any): Promise<void> {
        return MyStore.instance.dispatch(reducers.user.ActionTypes.fnSetUserInfo, value);
    }

    /** 
     * 设置 AccessToken 
     * @param value AccessToken
     * @param callBack 设置完成后回调函数
     */
    public setAccessToken(value: string, callBack: () => void) {
        const user = MyStore.instance.getState().user;
        user.aToken = value;
        MyStore.instance.dispatch(reducers.user.ActionTypes.fnSetUserInfo, user).then(callBack);
    }

    /** 获取在平台Code */
    public async oauth2Code(option: IOauth2CodeOptions) {
        return await platform.oauth2Code(this, option);
    }

    /** 平台Api */
    public get platformApi() {
        return platform;
    }

    /** 配置工具 */
    public get configUtils() {
        return configUtils;
    }

    /** 获取 Socket 实例 */
    public getSocket(): KtsSocket {
        return new KtsSocket(configUtils.socketUrl(), this.user.cToken);
    }

    /** 
     * 获取片面信息组件
     * @param type 膜拜类型 VAT_SPECIAL_INVOICE_MOTORVEHICLE（发动机票）
     * @param data 借口返回的数据
     * @param onClose 点击了关闭
     */
    public template(type: string, data: any, onClose: () => void) {
        return Template({ type, data, onClose });
    }

    /**
     * 显示发票录入 
     * @param urlData 接口地址参数
     * @param onRefresh 录入后回掉函数
     */
    public showInvoiceImport(urlData: any, onRefresh: () => void, title: string = '发票录入') {
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.add, {
            Components: <InvoiceImport urlData={urlData} refreshInvoice={onRefresh} />,
            title: title
        });
    }

    /** 显示选择公司 */
    public showCompanySelection(title: string, props: any) {
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.add, {
            Components: <CompanySelection {...props} />,
            title: title
        });
    }

    /**
     * 显示侧边栏
     * @param options 侧边栏选项
     */
    public showAside(options: any) {
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.add, options);
    }

    /** 隐藏侧边栏 */
    public hideAside() {
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.removeHide, null);
    }

    /** 隐藏侧边栏(所有) */
    public hideAsideAll() {
        MyStore.instance.dispatch(reducers.rightPopUps.ActionTypes.removeAll, null);
    }

    /** 切换公司 */
    public async switchCompany(companyId: string) {
        return switchCompany(companyId);
    }

    /** 监听消息 消息规则 */
    public onEvent(type: string, method: (e: Event) => void) {
        this.on(type, method);
    }

    /** 注销监听 */
    public offEvent(type: string, method: (e: Event) => void) {
        this.off(type, method);
    }

    /** 发送事件 */
    public sendEvent = (type: string, options: any) => {
        switch (type) {
            case 'MessageChangeEvent':
                this.send(new MessageChangeEvent(MessageChangeEvent.TYPE));
                break;

            default:
                this.send(new MessageChangeEvent(type, options));
                break;
        }
    }
}

/** 消息有变更 */
export class MessageChangeEvent extends Event {

    /** 消息有变更 */
    public static readonly TYPE: string = Message.createType('MessageChangeEvent');

    public options: any;

    /** 消息有变更 */
    constructor(type: string, options?: any) {
        super(type);
        this.options = options;
        message.messageCountUnread(this);
    }
}


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/appSdk/index.tsx